import React from "react";
import { Button, Icon } from "react-materialize";

export default function BtnSubmitAddByEmail({ handleEvents }) {
  return (
    <Button
      node="button"
      waves="light"
      className="btn-top-right"
      id="btn-submit-add-by-email"
      onClick={handleEvents.OnSubmit}
    >
      ADD NEW
      {/* <Icon right>email</Icon> */}
    </Button>
  );
}
